// src/main.js
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/main.css";
import "@/firebase/config";
import "./registerServiceWorker";
import { pinia } from "@/stores";
import { securityManager } from "@/composables/useSecurityManager";

const app = createApp(App);
app.use(pinia);
app.use(router);

// Initialize security manager
app.config.globalProperties.$security = securityManager;

// Watch for authentication changes and manage security
import { useAuthStore } from "@/stores/auth";

const watchAuth = () => {
  const authStore = useAuthStore();
  if (authStore.isAuthenticated) {
    securityManager.cleanup();
  } else {
    securityManager.init();
  }
};

// Initialize security on app start
watchAuth();

// Set up authentication watcher
import { watch } from "vue";
const authStore = useAuthStore();
watch(() => authStore.isAuthenticated, watchAuth);

app.mount("#app");
